import * as React from 'react';
import { EStarSize, Stars } from '@cian/frontend-reviews-components';
import { ArticleHeading4, UIText3, Avatar } from '@cian/ui-kit';
import * as style from './ReviewAuthor.css';
import { Link } from '../../Link';

export interface IReviewAuthorProps {
  avatarUrl: string;
  name: string;
  date: string;
  rating?: number;
  newbuildingName: string;
  newbuildingUrl: string;
}

export const ReviewAuthor: React.FC<IReviewAuthorProps> = ({
  avatarUrl,
  name,
  date,
  rating,
  newbuildingName,
  newbuildingUrl,
}) => {
  return (
    <div className={style['author']}>
      <div className={style['avatar']}>
        <Avatar size={48} src={avatarUrl} type={'user'} />
      </div>
      <div>
        <ArticleHeading4>{name}</ArticleHeading4>
        <div className={style['rating']}>
          {rating && (
            <div className={style['stars']}>
              <Stars size={EStarSize.M} value={rating} />
            </div>
          )}
          <UIText3>{date}</UIText3>
        </div>
        <div className={style['newbuilding']}>
          <Link url={newbuildingUrl} text={newbuildingName} fontweight="700" />
        </div>
      </div>
    </div>
  );
};
